import gql from 'graphql-tag'

export const DRIVER_LIST = gql`
  query DriverList(
    $id: Int,
    $employeeId: Int,
    $fullname: String,
    $email: String,
    $phonenumber: String,
    $status: DriverStatus,
    $offset: Int,
    $limit: Int,
    $orderBy: OrderBy,
    $orderField: DriverOrderField,
    $platenumber: String,
  ) {
    DriverList(input:{
      id:$id
      employeeId: $employeeId
      fullname: $fullname
      email: $email
      phonenumber: $phonenumber
      status: $status
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      orderField: $orderField
      platenumber: $platenumber
    }){
      lists {
        id
        employeeId
        fullname
        email
        fleetCode
        phonenumber
        isLeave
        status
        remainTickets
        remainFuel
        compensation
        platenumber
      }
      totalCount
      totalFilter
    }
  }
`

export const DRIVER_LIST_IN_SHIPPING_ORDER = gql`
  query DriverListInShippingorder(
    $id: Int,
    $employeeId: Int,
    $fullname: String,
    $email: String,
    $phonenumber: String,
    $status: DriverStatus,
    $offset: Int,
    $limit: Int,
    $checkDate: Date,
    $orderBy: OrderBy,
    $orderField: DriverOrderField,
    $platenumber: String,
  ) {
    DriverListInShippingorder(input:{
      id:$id
      employeeId: $employeeId
      fullname: $fullname
      email: $email
      phonenumber: $phonenumber
      status: $status
      offset: $offset
      limit: $limit
      checkDate: $checkDate
      orderBy: $orderBy
      orderField: $orderField
      platenumber: $platenumber
    }){
      lists {
        id
        employeeId
        fullname
        email
        fleetCode
        phonenumber
        status
        remainTickets
        remainFuel
        compensation
        platenumber
        shippings{
          id
          shippingCode
          shippingVolume
          shippingNumber
          status
          Truck {
            plateNumber
          }
          Customer {
            companyName
          }
          FuelOrder {
            totalAmount
            price
            status
          }
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const DRIVER_INFO = gql`
  query DriverInfo(
    $id: String,
  ) {
    DriverInfo(id: $id){
      success
      driver {
        id
        employeeId
        fullname
        fleetCode
        department
        startDate
        nationalId
        licenseId
        licenseExpire
        email
        phonenumber
        platenumber
        quitDate
        bankAccountNumber
        bankName
        insuranceNumber
        salary
        birthDate
        status
        compensation
        companyType
        remainTickets
        remainFuel
        truck {
          id
          plateNumber
        }
        createdAt
        updatedAt
        upcomingLeave {
          startDate
          endDate
          batchId
          remark
        }
        logs {
          id
          createdAt
          volumn
          number
          totalAmount
          totalDeduct
        }
      }
    }
  }
`

export const TRUCK_OWNER = gql`
  query TruckOwners {
    TruckOwners {
      lists {
        id
        nameTh
        type
      }
    }
  }
`

export const TRUCK_TYPE = gql`
  query TruckTypes {
    TruckTypes {
      lists {
        id
        nameTh
        minWeight
        maxWeight
      }
    }
  }
`

export const GET_FLEETS = gql`
  query FleetList {
    FleetList(
      input: {
        limit: 1000
      }
    ) {
      lists{
        id
        name
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_TRUCK_BRAND_LIST = gql`
  query TruckBrandList{
    TruckBrandList {
      lists{
        id
        name
        fuelConsumptionRate
      }
      totalCount
    }
  }
`

export const GET_TRUCK_LIST = gql`
  query TruckList (
    $id: Int,
    $plateNumber: String,
    $trailerNumber1: String,
    $fleet: String,
    $truckWeight: Int,
    $remark: String,
    $driver: FilterDriverInTruck,
    $owner: FilterTruckOwnerInTruck,
    $type: FilterTruckTypeInTruck,
    $createdAt: Date,
    $updatedAt: Date,
    $orderBy: OrderBy,
    $orderField: TruckOrderField,
    $limit: Int,
    $offset: Int,
    $status: FilterTruckStatus
    ) {
    TruckList(input: {
      id: $id
      plateNumber: $plateNumber
      trailerNumber1: $trailerNumber1
      fleet: $fleet
      truckWeight: $truckWeight
      remark: $remark
      driver: $driver
      owner: $owner
      type: $type
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      status: $status
    }){
      totalCount
      totalFilter
      lists {
        id
        plateNumber
        trailerNumber1
        status
        fuelType
        truckWeight
        remark
        driver {
          id
          employeeId
          fullname
          email
          fleetCode
          phonenumber
          status
          remainTickets
          remainFuel
          compensation
          platenumber
        }
        fleet
        owner {
          id
          type
          nameTh
        }
        type {
          id
          nameTh
        }
      }
    }
  }
`

export const TRUCK_LIST_IN_SHIPPING_ORDER = gql`
  query TruckListInShippingorder(
    $plateNumber: String,
    $limit: Int,
    $offset: Int,
  ){
    TruckListInShippingorder(input: {
      plateNumber: $plateNumber
      limit: $limit
      offset: $offset
    }) {
      totalCount
      totalFilter
      lists {
        trailer {
          trailerPlate
          id
          status
        }
        id
        plateNumber
        trailerNumber1
        TruckBrand{
          id
          name
          fuelConsumptionRate
        }
        status
        fuelType
        truckWeight
        remark
        trailer {
          id
          trailerPlate
          status
        }
        driver {
          id
          employeeId
          fullname
          email
          fleetCode
          phonenumber
          status
          remainTickets
          remainFuel
          compensation
          platenumber
          shippings {
            id
            shippingCode
            shippingVolume
            shippingNumber
            status
            Truck {
              plateNumber
            }
            Customer {
              companyName
            }
            FuelOrder {
              totalAmount
              price
              status
            }
          }
        }
        fleet
        owner {
          id
          type
          nameTh
        }
        type {
          id
          nameTh
        }
      }
    }
  }
`

export const GET_TRAILER_LIST = gql`
  query TrailerList(
    $id: Int,
    $trailerPlate: String,
    $chassisNumber: String,
    $createdAt: Date,
    $updatedAt: Date,
    $orderBy: OrderBy,
    $orderField: TrailerOrderField,
    $plateNumber: String,
    $nameTh: String,
    $limit: Int,
    $offset: Int,
    $isAvailable: Boolean,
    $status: TrailerStatus
  ){
    TrailerList(input: {
      id: $id
      trailerPlate: $trailerPlate
      chassisNumber: $chassisNumber
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      Truck: {
        plateNumber: $plateNumber
      }
      type: {
        nameTh: $nameTh
      }
      limit: $limit
      offset: $offset
      isAvailable: $isAvailable
      status: $status
    }){
      totalCount
      totalFilter
      lists {
        id
        trailerPlate
        chassisNumber
        trailerUsedLog{
          id
          truck {
            id
            plateNumber
            fleet
            fuelType
            truckWeight
            remark
            status
          }
          start
          end
        }
        truck {
          id
          plateNumber
        }
        type{
          id
          nameTh
        }
        status
        createdAt
        updatedAt
      }
    }
  }
`

export const TRAILER_INFO = gql`
  query TrailerInfo(
    $id: String,
  ){
    TrailerInfo(id: $id){
      id
      trailerPlate
      chassisNumber
      type  {
        id
        description
        nameTh
        minWeight
        maxWeight
      }
      trailerUsedLog {
        id
        truck {
          id
          plateNumber
        }
        start
        end
      }
      status
      createdAt
      updatedAt
    }
  }
`

export const TRUCK_INFO = gql`
  query TruckInfo(
    $id: String,
  ){
    TruckInfo(id: $id) {
      id
      plateNumber
      trailerNumber1
      TruckBrand{
        id
        name
        fuelConsumptionRate
      }
      status
      fuelType
      chassisNumber
      truckWeight
      remark
      driver {
        id
        fullname
        fleetCode
      }
      fleet
      owner {
        id
        type
        nameTh
      }
      type {
        id
        nameTh
      }
      trailerUsedLog{
        id
        trailer{
          trailerPlate
        }
        start
        end
      }
      trailer{
        id
        trailerPlate
        type {
          nameTh
        }
      }
    }
  }
`

export const GET_GARAGE_LIST = gql`
  query GarageList(
    $id: Int
    $name: String
    $phoneNumber: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: GarageOrderField
    $taxId: String
    $limit: Int
    $offset: Int
  ){
    GarageList(input:{
      id: $id
      name: $name
      phoneNumber: $phoneNumber
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      taxId: $taxId
      limit: $limit
      offset: $offset
    }){
      totalCount
      totalFilter
      lists{
        id
        name
        phoneNumber
        address
        taxId
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_TIRE_PATCH_SHOP_LIST = gql`
  query TirePatchStoreList(
    $id: Int
    $name: String
    $phoneNumber: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: TirePatchStoreOrderField
    $limit: Int
    $offset: Int
  ){
    TirePatchStoreList(input:{
      id: $id
      name: $name
      phoneNumber: $phoneNumber
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }){
      totalCount
      totalFilter
      lists{
        id
        name
        phoneNumber
        address
        taxId
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GARAGE = gql`
  query GarageInfo(
    $id: String
  ){
    GarageInfo(
      id: $id
    ){
    id
    name
    phoneNumber
    address
    taxId
    createdAt
    updatedAt
  }
  }
`

export const GET_TIRE_PATCH_SHOP = gql`
  query TirePatchStoreInfo(
    $id: String!
  ){
    TirePatchStoreInfo(
      id: $id
    ){
    id
    name
    phoneNumber
    address
    taxId
    createdAt
    updatedAt
  }
  }
`

export const GET_CLIENTS = gql`
  query getCustomerLists(
    $limit: Int
    $offset: Int
    $id: Int
    $companyId: String
    $companyName: String
    $contactName: String
    $email: String
    $orderBy: OrderBy
    $orderField: customerOrderField
    $typeOfChargeId: Int
    $type: CustomerType
    $branch: String
  ) {
    getCustomerLists(input: {
      limit: $limit
      offset: $offset
      id: $id
      companyId: $companyId
      companyName: $companyName
      contactName: $contactName
      email: $email
      orderBy: $orderBy
      orderField: $orderField
      type: $type
      typeOfChargeId: $typeOfChargeId
      branch: $branch
    }) {
      lists {
        id
        companyId
        companyName
        branch
        contactName
        contactNumber
        email
        officeNumber
        type
        TypeOfCharge {
          id
          name
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_CLIENT = gql`
  query customerInfo(
    $id: String
  ) {
    customerInfo(id: $id) {
      id
      companyId
      companyName
      branch
      credit
      companyAddress
      taxId
      officeNumber
      contactName
      contactNumber
      email
      fax
      rateType
      websiteUrl
      note
      type
      cargoType {
        id
        name
      }
      TypeOfCharge {
        id
        name
      }
      status
      images {
        filename
        url
      }
      groupId
      createdAt
      updatedAt
    }
  }
`
export const JOB_LIST = gql`
query JobList(
  $limit: Int
  $offset: Int
  $jobCode: String
  $volumn: String
  $number: String
  $createdAt: Date
  $companyId: String
  $companyName: String
  $typeOfChargeId: Int
  $contractStart: Date
  $contractEnd: Date
  $cargo: String
  $dealType: FILTERDEALTYPE
  $orderField: JobOrderField
  $orderBy: OrderBy
){
  JobList(input:{
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderField: $orderField
    jobCode: $jobCode
    volumn: $volumn
    number: $number
    createdAt: $createdAt
    Customer: {
      companyId: $companyId
      companyName: $companyName
      typeOfChargeId: $typeOfChargeId
    }
    contractStart: $contractStart
    contractEnd: $contractEnd
    cargo: $cargo
    dealType: $dealType
  }){
    totalFilter
    lists{
      id
      jobCode
      volumn
      number
      createdAt
      contractWeight
      deliveredWeight
      distance
      Customer{
        id
        companyId
        companyName
        branch
        TypeOfCharge {
          id
          name
        }
      }
      contractStart
      contractEnd
      cargo
      dealType
      unit
    }
  }
}
`

export const GET_ROLES = gql`
  query RoleList {
    RoleList {
      lists {
        id
        name
        description
        allowModules {
          groupId
          name
          description
          createdAt
          updatedAt
          Permissions {
            permissionId
            name
            description
            active
            createdAt
            updatedAt
          }
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_ROLE = gql`
  query RoleInfo(
    $id: String
  ) {
    RoleInfo(id: $id) {
      id
      name
      description
      allowModules {
        groupId
        name
        description
        createdAt
        updatedAt
        Permissions {
          name
          description
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`

export const GET_USERS = gql`
  query UserList(
    $userId: Int
    $email: String
    $firstname: String
    $name: String
    $lastname: String
    $telephone: String
    $profileImage: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: UserOrderField
    $position: String
    $status: FilterUserStatus
    $roleId: Int
    $limit: Int
    $offset: Int
  ) {
    UserList(input: {
      userId: $userId
      email: $email
      firstname: $firstname
      lastname: $lastname
      telephone: $telephone
      profileImage: $profileImage
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      position: $position
      status: $status
      roleId: $roleId
      limit: $limit
      offset: $offset
      name: $name
    }) {
      lists {
        userId
        email
        firstname
        lastname
        telephone
        position
        profileImage
        status
        Roles {
          id
          name
          description
          allowModules {
            groupId
            name
            description
            createdAt
            updatedAt
            Permissions {
              permissionId
              name
              description
              active
              createdAt
              updatedAt
            }
          }
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_USER = gql`
  query UserInfo(
    $id: String
  ) {
    UserInfo(id: $id) {
      userId
      email
      firstname
      lastname
      telephone
      driverId
      customerId
      senderLocationId
      receiverLocationId
      gasstationId
      position
      profileImage
      status
      Roles {
        id
        name
        description
        allowModules {
          groupId
          name
          description
          createdAt
          updatedAt
          Permissions {
            permissionId
            name
            description
            active
            createdAt
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      Warehouses{
        id
        warehouseName
      }
      Customer{
        id
        companyName
      }
      createdAt
      updatedAt
    }
  }
`

export const GET_JOB = gql`
  query JobInfo (
    $id: String
  ) {
    JobInfo (
      id: $id
    ) {
      id
      jobCode
      volumn
      number
      average
      companyType
      Customer {
        id
        companyId
        branch
        companyName
        TypeOfCharge {
          id
          name
        }
      }
      shippings {
        id
      }
      availableOrder
      customerId
      contractStart
      contractEnd
      cargo
      contractWeight
      truckOwnerFeeRate
      unit
      deliveredWeight
      feeRate
      remark
      dealType
      Jobfiles {
        id
        filename
        url
      }
      createdAt
      updatedAt
      startDestinationLocation {
        id
        name
        branch
        address
      }
      endDestinationLocation {
        id
        name
        branch
        address
      }
      feeRate
      distance
      predealPrice
    }
  }
`

export const GET_JOB_FOR_CUSTOMER = gql`
  query JobInfo (
    $id: String
  ) {
    JobInfo (
      id: $id
    ) {
      id
      number
      companyType
      Customer {
        id
        companyName
      }
      contractStart
      contractEnd
      cargo
      contractWeight
      unit
      deliveredWeight
      startDestinationLocation {
        id
        name
      }
      endDestinationLocation {
        id
        name
      }
    }
  }
`

export const GET_TYPE_OF_CHARGES = gql`
  query getTypeOfChargeList {
    getTypeOfChargeList {
      totalCount
      totalFilter
      lists{
        id
        name
      }
    }
  }
`

export const GAS_STATION_LIST = gql`
  query GasstationList (
      $id: Int
      $code: String
      $name: String
      $company: FilterGasstationCompany
      $contactnumber: String
      $remark: String
      $officialName: String
      $isActive: Boolean
      $createdAt: Date
      $updatedAt: Date
      $orderBy: OrderBy
      $orderField: GasstationOrderField
      $limit: Int
      $offset: Int
    ) {
    GasstationList(input: {
      id: $id
      code: $code
      name: $name
      company: $company
      contactnumber: $contactnumber
      remark: $remark
      officialName: $officialName
      isActive: $isActive
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      totalCount
      totalFilter
      lists {
        id
        code
        name
        officialName
        company
        contactnumber
        remark
        taxId
        creditTerm
        images {
          id
          url
          filename
        }
      }
    }
  }
`

export const GET_GAS_STATION = gql`
  query GasstationInfo (
    $id: String
  ) {
    GasstationInfo(
      id: $id
    ) {
      id
      code
      name
      company
      contactnumber
      remark
      taxId
      creditTerm
      email
      officialName
      isActive
      images {
        id
        url
        filename
      }
    }
  }
`

export const GET_TRUCK_OWNER = gql`
  query TruckownerList(
    $code: String
    $status: FilterTruckOwnerStatus
    $nameTh: String
    $nameEn : String
    $type: FilterTruckOwnerType
    $limit: Int
    $offset: Int
    $orderField: TruckownerOrderField
    $orderBy: OrderBy
  ) {
    TruckownerList(input:{
      code: $code
      status: $status
      nameTh: $nameTh
      nameEn: $nameEn
      type: $type
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderBy: $orderBy
    }){
      totalFilter
      lists
      {
        id
        nameTh
        description
        nameEn
        type
        code
        status
        rate
        taxId
      }
    }
  }
`
export const GET_TRUCK_OWNER_INFO = gql`
  query TruckownerInfo(
    $id: String!
  ){
    TruckownerInfo(
      id:$id
    ){
      id
      nameTh
      nameEn
      description
      type
      code
      status
      rate
      taxId
    }
  }
`

export const TRUCK_OWNER_REPORT_LOG_LIST = gql`
  query TruckOwnerReportLogsList(
    $truckOwnerId: Int
    $orderBy: OrderBy
    $orderField: TruckOwnerReportLogsOrderField
    $limit: Int
  ){
    TruckOwnerReportLogsList(input:{
      truckOwnerId: $truckOwnerId
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
    }) {
      lists {
        id
        truckOwnerId
        pricePerTon
        startDate
        endDate
        gps
        social
        withHoldingTax
        difference
        mechFee
        licenseFee
        insuranceFee
        etcFee
        sealFee
        tireFee
        rimFee
        partFee
        outsideRepairFee
        show
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const SHIPPING_ORDERS = gql`
  query ShippingorderList(
    $shippingVolume: String
    $shippingNumber: String
    $assignDate: Date
    $companyId: String
    $companyName: String
    $fullname: String
    $plateNumber: String
    $status: ShippingOrderStatusFilter
    $FuelOrder: ShippingOrderFuelOrderStatusFilter
    $startAssignDate: Date
    $endAssignDate: Date
    $startRecordDate: Date
    $endRecordDate: Date
    $startCreatedAt: Date
    $endCreatedAt: Date
    $startDeliveryDate: Date
    $endDeliveryDate: Date
    $limit: Int
    $offset: Int
    $key: String
    $orderBy: OrderBy
    $orderField: ShippingorderOrderField
    $driverId: Int
    $isChanged: Boolean
  ) {
    ShippingorderList(input: {
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
      assignDate: $assignDate
      key: $key
      isChanged: $isChanged
      Customer: {
        companyId: $companyId
        companyName: $companyName
      }
      Driver: {
        fullname: $fullname
        id: $driverId
      }
      Truck: {
        plateNumber: $plateNumber
      }
      status: $status
      FuelOrder: {
        status: $FuelOrder
      }
      startDeliveryDate: $startDeliveryDate
      endDeliveryDate: $endDeliveryDate
      startAssignDate: $startAssignDate
      endAssignDate: $endAssignDate
      startRecordDate: $startRecordDate
      endRecordDate: $endRecordDate
      startCreatedAt: $startCreatedAt
      endCreatedAt: $endCreatedAt
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderField: $orderField
    }) {
      lists {
        id
        shippingCode
        shippingVolume
        shippingNumber
        assignDate
        status
        totalWeight
        feeTotal
        unit
        deliveryDate
        deliveryTime
        pickedUpDate
        pickedUpTime
        compensation
        Driver {
          id
          fullname
        }
        Truck {
          id
          plateNumber
          trailerNumber1
        }
        Customer {
          id
          companyId
          branch
          companyName
          credit
          groupId
        }
        FuelOrder {
          id
          status
        }
        FuelOrders {
          id
          status
          isSpecial
        }
        Job {
          id
          dealType
          companyType
          shippings {
            id
          }
          availableOrder
        }
        images{
          id
          url
          filename
        }
        createdAt
        updatedAt
        startWeight
        endWeight
        roundWeight
        emptySackAmount
        outTownFeeRate
        specialFeeRate
        startDestinationLocation {
          id
          name
        }
        endDestinationLocation {
          id
          name
        }
        weightDifference
        feeRate
        weightRecordId
      }
      totalCount
      totalFilter
    }
  }
`

const SHIPPING_ORDERS_FOR_MOBILE = gql`
  query ShippingorderList(
    $shippingVolume: String
    $shippingNumber: String
    $assignDate: Date
    $companyId: String
    $companyName: String
    $fullname: String
    $plateNumber: String
    $status: ShippingOrderStatusFilter
    $FuelOrder: ShippingOrderFuelOrderStatusFilter
    $startAssignDate: Date
    $endAssignDate: Date
    $startRecordDate: Date
    $endRecordDate: Date
    $startCreatedAt: Date
    $endCreatedAt: Date
    $startDeliveryDate: Date
    $endDeliveryDate: Date
    $limit: Int
    $offset: Int
    $key: String
    $orderBy: OrderBy
    $orderField: ShippingorderOrderField
    $driverId: Int
  ) {
    ShippingorderList(input: {
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
      assignDate: $assignDate
      key: $key
      Customer: {
        companyId: $companyId
        companyName: $companyName
      }
      Driver: {
        fullname: $fullname
        id: $driverId
      }
      Truck: {
        plateNumber: $plateNumber
      }
      status: $status
      FuelOrder: {
        status: $FuelOrder
      }
      startDeliveryDate: $startDeliveryDate
      endDeliveryDate: $endDeliveryDate
      startAssignDate: $startAssignDate
      endAssignDate: $endAssignDate
      startRecordDate: $startRecordDate
      endRecordDate: $endRecordDate
      startCreatedAt: $startCreatedAt
      endCreatedAt: $endCreatedAt
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderField: $orderField
    }) {
      lists {
        id
        shippingCode
        shippingVolume
        shippingNumber
        assignDate
        status
        totalWeight
        feeTotal
        unit
        deliveryDate
        deliveryTime
        Driver {
          id
          fullname
        }
        Truck {
          id
          plateNumber
          trailerNumber1
        }
        Customer {
          id
          companyId
          branch
          companyName
          credit
          groupId
        }
        FuelOrder {
          id
          status
        }
        Job{
          id
          dealType
          cargo
        }
        createdAt
        updatedAt
        startWeight
        endWeight
        roundWeight
        emptySackAmount
        outTownFeeRate
        specialFeeRate
        weightDifference
        feeRate
        weightRecordId
      }
      totalCount
      totalFilter
    }
  }
`

export const JOB_SEARCH = gql`
  query searchJobByVolumnNumber(
    $key: String
  ) {
    searchJobByVolumnNumber(input: {
      key: $key
    }) {
      lists {
        key
        id
        number
        volumn
        jobInfo {
          id
          Customer {
            id
            companyId
            branch
            companyName
            credit
            groupId
          }
          availableOrder
          shippings {
            id
          }
          cargo
          contractEnd
          contractWeight
          deliveredWeight
          dealType
          unit
          feeRate
          predealPrice
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const FUEL_ORDER_LIST = gql`
  query FuelOrderList(
    $id: Int
    $shippingVolume: String
    $shippingNumber: String
    $assignDate: Date
    $name: String
    $expiredDate: Date
    $company: FilterGasstationCompany
    $totalAmount: Float
    $status: FuelOrderStatusFilter
    $orderBy: OrderBy
    $orderField: FuelOrderOrderField
    $limit: Int
    $offset: Int
    $driverId: Int
    $isSpecial: Boolean
  ) {
    FuelOrderList(input: {
      id: $id
      shippingVolume: $shippingVolume
      shippingNumber: $shippingNumber
      ShippingOrder: {
        assignDate: $assignDate
      }
      Gasstation: {
        name: $name
        company: $company
      }
      totalAmount: $totalAmount
      status: $status
      expiredDate: $expiredDate
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      driverId: $driverId
      isSpecial: $isSpecial
    }) {
      totalCount
      totalFilter
      lists {
        id
        isSpecial
        shippingVolume
        shippingNumber
        ShippingOrder {
          id
          assignDate
          status
          Truck {
            id
            plateNumber
          }
        }
        Gasstation {
          id
          name
          company
        }
        isPaidByFleetCard
        filledAmount
        availableAmount
        totalAmount
        pricePerLitre
        status
        expiredDate
        fuelType
        remark
        files {
          id
          url
          filename
        }
      }
    }
  }
`

export const FUEL_ORDER_INFO = gql`
  query FuelOrderInfo(
    $id: String
  ) {
    FuelOrderInfo(id: $id) {
      id
      isSpecial
      specialReason
      specialReasonOther
      pricePerLitre
      kmPerLitre
      totalAmount
      price
      fuelType
      status
      remark
      fuelcompensation {
        id
        totalDeduct
        nextOrder
      }
      files {
        id
        url
        filename
      }
      logs {
        id
        fuelId
        userId
        amount
      }
      filledAmount
      availableAmount
      isPaidByFleetCard
      shippingVolume
      shippingNumber
      ShippingOrder {
        id
        shippingCode
        assignDate
        startDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        endDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        TruckOwner{
          id
          nameTh
          type
        }
        Truck {
          id
          plateNumber
          fleet
          type {
            id
            nameTh
          }
          driver {
            id
            fullname
            employeeId
          }
        }
        Driver {
          id
          employeeId
          fullname
          totalFuelamountCompensation
          compensation
        }
        startTime
        Job {
          id
          jobCode
          volumn
          number
          dealType
          Customer {
            id
            companyName
            branch
            companyId
            TypeOfCharge {
              id
              name
            }
          }
        }
      }
      Gasstation {
        id
        name
        code
        company
      }
      createdAt
      updatedAt
      expiredDate
    }
  }
`

export const SHIPPING_ORDER = gql`
  query ShippingorderInfo(
    $id: String
    $shippingNumber: String
    $shippingVolume: String
  ) {
    ShippingorderInfo(
      id: $id
      shippingNumber: $shippingNumber
      shippingVolume: $shippingVolume
    ) {
      id
      shippingCode
      shippingVolume
      shippingNumber
      customerId
      jobId
      startDestination
      endDestination
      containerOption
      truckId
      driverId
      assignDate
      startTime
      startWeight
      outTownFeeRate
      specialFeeRate
      endWeight
      expense
      recordDate
      tariff
      rateType
      expensesHighway
      expensesEntranceStart
      expensesEntranceEnd
      expensesPickupStart
      expensesPickupEnd
      expensesOther
      feePickupHeavy
      feePierEntrance
      feePickupNormal
      feeOther
      weightRecordId
      roundWeight
      bookingNo
      emptySackAmount
      truckOwnerFeeRate
      startDestinationLocation {
        id
        name
        branch
        address
        createdAt
        updatedAt
      }
      endDestinationLocation {
        id
        name
        branch
        address
        createdAt
        updatedAt
      }
      weightDifferenceLimit
      unit
      totalWeight
      deliveryDate
      deliveryTime
      pickedUpDate
      pickedUpTime
      compensation
      truckWithCargoWeight
      variableShippingFee
      feeRate
      feeTotal
      fixedShippingFee
      remark
      status
      Driver {
        id
        employeeId
        fullname
        department
        platenumber
        status
        compensation
        totalFuelamountCompensation
        remainTickets
        remainFuel
      }
      TruckOwner {
        id
        type
        nameTh
      }
      Trailer {
        trailerPlate
        status
        id
      }
      Truck {
        trailer {
          trailerPlate
          id
          status
        }
        id
        plateNumber
        fuelType
        status
        driver {
          id
          employeeId
          fullname
        }
        owner {
          id
          type
          nameTh
        }
        type {
          id
          nameTh
          maxWeight
        }
        trailer {
          id
          trailerPlate
          status
        }
        TruckBrand{
          id
          name
          fuelConsumptionRate
        }
      }
      Job {
        id
        jobCode
        volumn
        number
        dealType
        distance
        availableOrder
        shippings {
          id
        }
        startDestinationLocation {
          id
          name
          branch
          address
        }
        endDestinationLocation {
          id
          name
          branch
          address
        }
        unit
      }
      Customer {
        id
        companyId
        branch
        companyName
        groupId
        TypeOfCharge {
          id
          name
        }
      }
      FuelOrder {
        id
        shippingVolume
        shippingNumber
        fuelType
        status
        pricePerLitre
        kmPerLitre
        totalAmount
        filledAmount
        expiredDate
        isPaidByFleetCard
        isSpecial
        fuelcompensation {
          totalDeduct
        }
        Gasstation {
          code
          id
          company
          name
        }
      }
      FuelOrders {
        id
        fuelType
        status
        shippingVolume
        shippingNumber
        pricePerLitre
        kmPerLitre
        totalAmount
        filledAmount
        expiredDate
        isPaidByFleetCard
        isSpecial
        specialReason
        specialReasonOther
        fuelcompensation {
          totalDeduct
        }
        Gasstation {
          code
          id
          company
          name
        }
      }
      images {
        id
        url
        filename
      }
      createdAt
      updatedAt
      remainingFuelAtStamp
      totalAmountAtStamp
      recommendAtStamp
      remainingFuelShippingOrder {
        remainingFuel {
          fuelOrder {
            shippingVolume
            shippingNumber
          }
        }
        reservedAmount
      }
    }
  }
`

export const INVOICE_LIST = gql`
  query InvoiceList(
    $id: Int
    $refId: String
    $volume: Int
    $number: Int
    $paidDate: Date
    $dueDate: Date
    $status: FilterInvoiceType
    $orderBy: OrderBy
    $orderField: InvoiceOrderField
    $limit: Int
    $offset: Int
    $jobCode: String
    $jobNumber: String
    $customerRefId: String
    $customerId: Int
    $peakSynced: Boolean
  ) {
    InvoiceList(input: {
      id: $id
      refId: $refId
      volume: $volume
      number: $number
      paidDate: $paidDate
      dueDate: $dueDate
      status: $status
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      jobCode: $jobCode
      customerRefId: $customerRefId
      peakSynced: $peakSynced
      Job: {
        number: $jobNumber
        customerId: $customerId
      }
    }) {
      totalCount
      totalFilter
      lists {
        id
        peakSynced
        refId
        volume
        number
        createdDate
        paidDate
        dueDate
        shippingGrandTotal
        customerRefId
        shippings {
          id
        }
        payment {
          id
          grandTotal
          amountReceived
          amountWithHeld
          customerBankFees
          pdrBankFees
          withHoldingTax
        }
        Job {
          id
          jobCode
          volumn
          number
          dealType
          Customer {
            id
            companyId
            branch
            credit
            companyName
            TypeOfCharge {
              id
              name
            }
          }
        }
        status
      }
    }
  }
`

export const INVOICE_INFO = gql`
  query InvoiceInfo($id: String) {
    InvoiceInfo(id: $id) {
      id
      refId
      volume
      number
      createdDate
      dueDate
      paidDate
      customerRefId
      shippingGrandTotal
      pricePerLitre
      feeRate
      revenueRecordDate
      payment {
        id
        bank
        bankNumber
        chequeNumber
        chequeDate
        grandTotal
        withHoldingTax
        amountWithHeld
        customerBankFees
        pdrBankFees
        amountReceived
        bankNumber
        type
        createdAt
        updatedAt
        shippings{
          id
          totalWeight
          endWeight
          shippingCode
          shippingVolume
          weightRecordId
          shippingNumber
          assignDate
          Truck {
            id
            plateNumber
            trailerNumber1
          }
          feeRate
          feeTotal
          startTime
          startDestinationLocation {
            id
            name
            branch
            address
            createdAt
            updatedAt
          }
          endDestinationLocation {
            id
            name
            branch
            address
            createdAt
            updatedAt
          }
          deliveryDate
          unit
          startWeight
          endWeight
          weightDifference
        }
        lostWeightFee
        damagedGoodFee
        lostInsuranceFee
        discountFee
        paidDate
        lateTicketFee
        excessPaymentFee
        accidentFee
      }
      Job {
        id 
        jobCode
        volumn
        number
        customerId
        dealType
        companyType
        Customer {
          id
          companyId
          branch
          companyName
          credit
          groupId
          cargoType {
            id
            name
          }
        }
        cargo
        contractWeight
        deliveredWeight
        unit
      }
      avaliableShippings {
        id
        feeTotal
      }
      shippings {
        id
        totalWeight
        endWeight
        shippingCode
        shippingVolume
        weightRecordId
        shippingNumber
        assignDate
        Truck {
          id
          plateNumber
          trailerNumber1
        }
        Trailer {
          trailerPlate
        }
        feeRate
        feeTotal
        startTime
        startDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        endDestinationLocation {
          id
          name
          branch
          address
          createdAt
          updatedAt
        }
        deliveryDate
        unit
        startWeight
        endWeight
        weightDifference
      }
      status
      remark
      files {
        id
        url
        filename
      }
    }
  }
`

export const GET_SUM_INFO_INVOICE = gql`
  query calculateDeliveredShipping ($id: [Int]!, $invoiceId: Int!) {
    calculateDeliveredShipping(input: { id: $id , invoiceId: $invoiceId}) {
      totalCount
      totalPrice
      totalWeight
      totalFuelPrice
    }
  }
`

export const GET_QRCODE = gql`
  query getFuelOrderQRCode ($id: Int!) {
    getFuelOrderQRCode(input: { id: $id }){
      data {
        image
      }
    }
  }
`

export const GET_PERMS = gql`
  query MyPerm {
    MyPerm {
      success
      message
      myRole
      data {
        perms {
          id
          name
        }
        menu {
          id
          key
        }
      }
    }
  }
`

export const GET_NOTI = gql`
  query showAllNoti (
    $limit: Int
    $offset: Int
    $orderField: String
    $orderBy: OrderBy
  ) {
    showAllNoti (input: {
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderBy: $orderBy
    }) {
      countAll
      notiAll {
        id
        read
        message
        mainModule
        subModule
        createdAt
        updatedAt
      }
      countUnread
      notiUnread {
        id
        read
        message
        mainModule
        subModule
        createdAt
        updatedAt
      }
    }
  }
`

export const BILL_LIST = gql`
  query BillList (
    $id: Int
    $refId: String
    $createdDate: Date
    $dueDate: Date
    $status: FilterBillType
    $companyName: String
    $orderBy: OrderBy
    $orderField: BillOrderField
    $limit: Int
    $offset: Int
  ) {
    BillList (input: {
      id: $id
      refId: $refId
      createdDate: $createdDate
      dueDate: $dueDate
      companyName: $companyName
      status: $status
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      totalCount
      totalFilter
      lists {
        id
        refId
        createdDate
        Job {
          Customer {
            id
            branch
            companyName
          }
        }
        grandTotal
        dueDate
        amountReceived
        status
        payment {
          id
          bank
          bankNumber
          chequeNumber
          chequeDate
          grandTotal
          withHoldingTax
          amountWithHeld
          customerBankFees
          pdrBankFees
          amountReceived
          type
        }
      }
    }
  }
`

export const BILL_INFO = gql`
  query BillInfo (
    $id: String
  ) {
    BillInfo (id: $id) {
      id
      refId
      dueDate
      paidDate
      createdDate
      status
      Job {
        jobCode
        volumn
        number
        dealType
        companyType
        Customer {
          id
          companyId
          companyName
          branch
          groupId
          typeOfChargeId
          TypeOfCharge {
            id
            name
          }
        }
      }
      grandTotal
      amountReceived
      payment {
        id
        bank
        bankNumber
        chequeNumber
        chequeDate
        grandTotal
        amountWithHeld
        withHoldingTax
        amountReceived
        customerBankFees
        pdrBankFees
        type
        lostWeightFee
        damagedGoodFee
        lostInsuranceFee
        discountFee
        lateTicketFee
        excessPaymentFee
        accidentFee
      }
      invoices {
        id
        refId
        dueDate
        customerRefId
        shippingGrandTotal
        Job {
          id
          number
        }
        payment {
          id
          grandTotal
          amountWithHeld
          amountReceived
        }
        shippings {
          id
        }
      }
      remark
      files {
        id
        url
        filename
      }
    }
  }
`

export const INVOICE_PAYMENT_LIST = gql`
  query InvoicePaymentList (
    $bankNumber: String
    $chequeNumber: String
    $type: InvoicePaymentType
  ) {
    InvoicePaymentList (input:{
      bankNumber: $bankNumber
      chequeNumber: $chequeNumber
      type: $type
    }) {
      lists{
        id
        chequeNumber
        bankNumber
      }
      totalCount
      totalFilter
    }
  }
`

export const BILL_PAYMENT_LIST = gql`
  query BillPaymentList (
    $bankNumber: String
    $chequeNumber: String
    $type: BillPaymentType
  ) {
    BillPaymentList (input:{
      bankNumber: $bankNumber
      chequeNumber: $chequeNumber
      type: $type
    }) {
      lists{
        id
        chequeNumber
        bankNumber
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_SENDERS = gql`
  query SenderLocationList (
    $id: Int
    $name: String
    $branch: String
    $address: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: SenderLocationOrderField
    $limit: Int
    $offset: Int
  ) {
      SenderLocationList (input: {
        id: $id
        name: $name
        branch: $branch
        address: $address
        createdAt: $createdAt
        updatedAt: $updatedAt
        orderBy: $orderBy
        orderField: $orderField
        limit: $limit
        offset: $offset
    }) {
      lists {
        id
        name
        branch
        address
        taxId
        createdAt
        updatedAt
        thaiGPSId
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_SENDER = gql`
  query SenderLocationInfo (
    $id: String
  ) {
    SenderLocationInfo (
      id: $id
    ) {
      id
      name
      branch
      address
      taxId
      createdAt
      updatedAt
    }
  }
`

export const GET_RECEIVERS = gql`
  query ReceiverLocationList (
    $id: Int
    $name: String
    $branch: String
    $address: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: ReceiverLocationOrderField
    $limit: Int
    $offset: Int
  ) {
    ReceiverLocationList (
      input: {
        id: $id
        name: $name
        branch: $branch
        address: $address
        createdAt: $createdAt
        updatedAt: $updatedAt
        orderBy: $orderBy
        orderField: $orderField
        limit: $limit
        offset: $offset
      }
    ) {
      lists {
        id
        name
        branch
        address
        taxId
        createdAt
        updatedAt
        thaiGPSId
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_RECEIVER = gql`
  query ReceiverLocationInfo (
    $id: String
  ) {
    ReceiverLocationInfo (
      id: $id
    ) {
      id
      name
      branch
      address
      taxId
      createdAt
      updatedAt
    }
  }
`

export const GET_LOGS = gql`
  query LogList(
    $moduleName: LogModules
    $fullname: String
    $type: LogType
    $limit: Int
    $offset: Int
    $createdAt: [Date]
    $refId: Int
    $roleId: Int
  ) {
    LogList(input: {
      moduleName: $moduleName
      fullname: $fullname
      type: $type
      limit: $limit
      offset: $offset
      createdAt: $createdAt
      refId: $refId
      roleId: $roleId
    }) {
      lists {
        id
        moduleName
        message
        actor {
          userId
          firstname
          lastname
          fullname
          Roles {
            id
            name
            description
          }
        }
        type
        refId
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_JOB_HISTORY = gql`
  query JobHistoryList(
    $jobId: String!
    $limit: Int
    $offset: Int
    $orderBy: OrderBy
    $orderField: String
  ) {
    LogList(input: {
      moduleName: JOB
      refId: $jobId
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      orderField: $orderField
    }) {
      lists {
        id
        message
        actor {
          userId
          firstname
          lastname
          fullname
        }
        type
        refId
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_REPAIR_JOBS = gql`
  query RepairJobList (
    $id: Int
    $fullname: String
    $plateNumber: String
    $createdAt: Date
    $orderBy: OrderBy
    $orderField: RepairJobOrderField
    $limit: Int
    $offset: Int
    $status: FilterRepairJobStatus
    $truckOwner: FilterTruckOwnerInRepairJob
    $warehouseId: Int
    $refId: String
  ) {
      RepairJobList (input: {
        id: $id
        CreatedBy: {
          fullname: $fullname
        }
        Truck: {
          plateNumber: $plateNumber
          truckOwner: $truckOwner
        }
        createdAt: $createdAt
        orderBy: $orderBy
        orderField: $orderField
        limit: $limit
        offset: $offset
        status: $status
        warehouseId: $warehouseId
        refId: $refId
    }) {
      lists {
        id
        refId
        truckId
        description
        currentFuel
        currentMile
        remark
        status
        deadlineDate
        createdBy
        cancelReason
        isOverDue
        services {
          id
          repairId
          status
          mechanicId
          remark
          cancelReason
          Mechanic {
            id
            firstname
            lastname
            department
            email
            startDate
            nationalId
            phoneNumber
            quitDate
            bankAccountNumber
            bankName
            salary
            birthDay
            insuranceNumber
            skills {
              id
              name
            }
            createdAt
            updatedAt
          }
          ItemBorrows {
            id
            name
            amount
            sku
            serialNo
            type
            createdAt
            updatedAt
          }
          ItemReturns {
            id
            name
            amount
            sku
            serialNo
            type
            createdAt
            updatedAt
          }
          BeforeRepairFiles {
            id
            url
            filename
            createdAt
            updatedAt
          }
          AfterRepairFiles {
            id
            url
            filename
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        Truck {
          id
          plateNumber
          trailerNumber1
          TruckBrand{
            id
            name
            fuelConsumptionRate
          }
          fleet
          fuelType
          owner {
            id
            description
            code
            type
            nameTh
            nameEn
          }
          type {
            id
            nameTh
          }
          status
        }
        files {
          id
          url
          filename
        }
        CreatedBy {
          userId
          email
          firstname
          lastname
          fullname
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const GET_MECHANICS = gql`
  query MechanicList(
    $firstname: String
    $lastname: String
    $fullname: String
    $department: String
    $email: String
    $phoneNumber: String
    $createdAt: Date
    $updatedAt: Date
    $orderBy: OrderBy
    $orderField: MechanicOrderField
    $limit: Int
    $offset: Int
  ) {
    MechanicList(input: {
      firstname: $firstname
      lastname: $lastname
      fullname: $fullname
      department: $department
      email: $email
      phoneNumber: $phoneNumber
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
    }) {
      totalCount
      totalFilter
      lists {
        id
        firstname
        lastname
        fullname
        department
        email
        startDate
        nationalId
        phoneNumber
        quitDate
        bankAccountNumber
        bankName
        salary
        birthDay
        insuranceNumber
        skills {
          id
          name
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      totalCount
      totalFilter
    }
  }
`

export const GASSTATION_FUEL_SUMMARY_BY_YEAR = gql`
  query GasstationFuelSummaryByYear(
    $companyType: CompanyType!
    $year: Date!
  ) {
    GasstationFuelSummaryByYear(input: {
      companyType: $companyType
      year: $year
    }) {
      data{
        month
        erpFleetCost
        erpNonFleetCost
        erpFleetFuelQuantity
        erpNonFleetFuelQuantity
      }
      success
      message
    }
  }
`

export const GASSTATION_FUEL_SUMMARY_BY_MONTH = gql`
  query GasstationFuelSummaryByMonth(
    $companyType: CompanyType!
    $month: Date!
    $gasstationId: Int
  ) {
    GasstationFuelSummaryByMonth(input: {
      companyType: $companyType
      month: $month
      gasstationId: $gasstationId
    }) {
      data{
        date
        erpFleetCost
        erpNonFleetCost
        fleetCardCost
        erpFleetFuelQuantity
        erpNonFleetFuelQuantity
        fleetCardFuelQuantity
      }
      success
      message
    }
  }
`

export const FUEL_SUMMARIES_BY_MONTH = gql`
  query FuelSummariesByMonth(
    $companyType: CompanyType!
    $month: Date!
  ) {
    FuelSummariesByMonth(input: {
      companyType: $companyType
      month: $month
    }) {
      data{
        company
        companyData{
          id
          date
          erpFleetCost
          erpNonFleetCost
          fleetCardCost
          erpFleetFuelQuantity
          erpNonFleetFuelQuantity
          fleetCardFuelQuantity
          Gasstation{
            id
            name
            officialName
          }
        }
      }
      success
      message
    }
  }
`

export const GET_MECHANIC = gql`
  query MechanicInfo(
    $id: String
  ) {
    MechanicInfo(id: $id) {
      id
      firstname
      lastname
      department
      email
      startDate
      nationalId
      phoneNumber
      quitDate
      bankAccountNumber
      bankName
      salary
      birthDay
      companyType
      insuranceNumber
      skills {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`

export const GET_SKILL_LIST = gql`
  query RepairSkillList {
    RepairSkillList {
      lists {
        id
        name
      }
    }
  }
`

export const EXPENSE = gql`
  query showExpense(
    $startDate: Date!
    $endDate: Date!
  ) {
    showExpense(
      input: {
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      success
      expenseInfo {
        summaryTotal {
          fleetName
          expense
          rubberCost
          partsCost
          oilCost
          gasCost
          salary
          compensation
        }
        summaryPadoongrich {
          fleetName
          totalExpense
          expensesHighway
          expensesEntrance
          expensesPickup
          expensesOther
          totalFee
          feePickupHeavy
          feePierEntrance
          feePickupNormal
          feeOther
        }
        padoongrichBarChart {
          expensesHighway
          expensesEntrance
          expensesPickup
          expensesOther
          feePickupHeavy
          feePierEntrance
          feePickupNormal
          feeOther
        }
        totalBarChart {
          expense
          rubberCost
          partsCost
          oilCost
          gasCost
          salary
          compensation
        }
        padoongrichTable {
          fleetName
          totalExpense
          expensesHighway
          expensesEntrance
          expensesPickup
          expensesOther
          totalFee
          feePickupHeavy
          feePierEntrance
          feePickupNormal
          feeOther
        }
        totalTable {
          fleetName
          expense
          rubberCost
          partsCost
          oilCost
          gasCost
          salary
          compensation
        }
      }
    }
  }
`

export const CHECK_PRICE = gql`
  query searchLastestInputFromLocation (
    $startDestination: Int!
    $endDestination: Int!
  ) {
    searchLastestInputFromLocation (input: {
      startDestination: $startDestination
      endDestination: $endDestination
    }) {
      jobInfo {
        feeRate
        distance
      }
    }
  }
`

export const GET_REPAIR_JOB_INFO = gql`
  query RepairJobInfo($id: String) {
    RepairJobInfo (id: $id) {
      id
      refId
      truckId
      description
      currentFuel
      currentMile
      remark
      status
      deadlineDate
      cancelReason
      isOverDue
      isOutsource
      outsourceType
      outsourceTel
      outsourceName
      outsourceRemark
      phoneNumber
      expense
      expenseTire
      Warehouse{
        warehouseCode
        warehouseName
        id
      }
      Trailer{
        trailerPlate
        id
        status
      }
      isRepairTruck
      repairTruckType
      repairTruckTypeOther
      isRepairTrailer
      repairTrailerType
      repairTrailerTypeOther
      Garage {
        id
        name
        phoneNumber
        address
      }
      Truck {
        id
        plateNumber
        status
        owner {
          id
          type
          nameTh
        }
        type {
          id
          nameTh
        }
        driver {
          fullname
          phonenumber
        }
      }
      Driver {
          fullname
          phonenumber
        }
      TireCarrierDriver {
        id
        fullname
        phonenumber
      }
      services {
        id
        repairId
        status
        mechanicId
        remark
        cancelReason
        Mechanic {
          id
          firstname
          lastname
          fullname
          department
          email
          startDate
          nationalId
          phoneNumber
          quitDate
          bankAccountNumber
          bankName
          salary
          birthDay
          insuranceNumber
          skills {
            id
            name
          }
          createdAt
          updatedAt
        }
        ItemBorrows {
          id
          name
          amount
          sku
          serialNo
          type
          createdAt
          updatedAt
          serialId
          pricePerItem
          InventoryOption{
            id
            buyPrice
          }
        }
        ItemReturns {
          id
          name
          amount
          sku
          serialNo
          type
          createdAt
          updatedAt
          serialId
          InventoryOption{
            id
            buyPrice
          }
        }
        BeforeRepairFiles {
          id
          url
          filename
          createdAt
          updatedAt
        }
        AfterRepairFiles {
          id
          url
          filename
          createdAt
          updatedAt
        }
        isRepairTruck
        isRepairTrailer
        serviceType
        RepairSkill{
          id
          name
        }
        createdAt
        updatedAt
      }
      files {
        id
        url
        filename
      }
      # services
      CreatedBy {
        userId
      }
      price
      fuels{
        id
        pricePerLitre
        kmPerLitre
        totalAmount
        price
        fuelType
        createdAt
        updatedAt
        expiredDate
        start
        end
        Gasstation{
          id
          name
        }
      }
      closeDate
      createdAt
      updatedAt      
    }
  }
`
export const CARGO_TYPE_LIST = gql`
  query cargoList {
    cargoList {
      id
      name
    }
  }
`
export const CUSTOMER_GROUP_LIST = gql`
  query CustomerGroupList(
    $limit: Int
  ) {
    CustomerGroupList(input: {
        limit: $limit
    }) {
      lists {
        id
        name
      }
    }
  }
`
export const GET_REVENUE = gql`
  query RevenueYearlyReport (
    $date: Date!
  ) {
    RevenueYearlyReport (input: {
      date: $date
    }) {
      date
      revenue
      expense
      diff
    }
  }
`
export const GET_TRUCK_LIST_IN_REPAIR_SERVICE = gql`
  query TruckList (
    $id: Int,
    $plateNumber: String,
    $trailerNumber1: String,
    $fleet: String,
    $truckWeight: Int,
    $remark: String,
    $driver: FilterDriverInTruck,
    $owner: FilterTruckOwnerInTruck,
    $type: FilterTruckTypeInTruck,
    $createdAt: Date,
    $updatedAt: Date,
    $orderBy: OrderBy,
    $orderField: TruckOrderField,
    $limit: Int,
    $offset: Int,
    $status: FilterTruckStatus
    ) {
    TruckList(input: {
      id: $id
      plateNumber: $plateNumber
      trailerNumber1: $trailerNumber1
      fleet: $fleet
      truckWeight: $truckWeight
      remark: $remark
      driver: $driver
      owner: $owner
      type: $type
      createdAt: $createdAt
      updatedAt: $updatedAt
      orderBy: $orderBy
      orderField: $orderField
      limit: $limit
      offset: $offset
      status: $status
    }){
      totalCount
      totalFilter
      lists {
        id
        plateNumber
        trailerNumber1 
        TruckBrand{
          id
          name
          fuelConsumptionRate
        }
        status
        fuelType
        truckWeight
        remark
        driver {
          id
          employeeId
          fullname
          email
          fleetCode
          phonenumber
          status
          remainTickets
          remainFuel
          compensation
          platenumber
        }
        fleet
        owner {
          id
          type
          nameTh
        }
        type {
          id
          nameTh
        }
        trailer{
          trailerPlate
          id
          status
        }
      }
    }
  }
`
export const GET_WAREHOUSE_LISTS = gql`
query warehouseList{
  warehouseList{
    data{
      list{
        id
        warehouseName
      }
    }
  }
}
`

export const GET_SHIPPING_ORDER_QR_CODE = gql`
  query getShippingorderQRCode (
    $id: Int!
  ) {
    getShippingorderQRCode (input: {
      id: $id
    }) {
      data {
        image
      }
    }
  }
`

export const DRIVER_COMPENSATION = gql`
  query DriverCompensationList (
    $id: Int
    $driverId: Int!
    $compensationDate: Date!
    $compensationPeriod: Float
    $limit: Int
    $offset: Int
  ) {
    DriverCompensationList (input: {
      id: $id
      driverId: $driverId
      compensationDate: $compensationDate
      compensationPeriod: $compensationPeriod
      limit: $limit
      offset: $offset
    }) {
      lists {
        id
        compensationDate
        compensationPeriod
        compensation
        Shippingorders {
          id
          shippingNumber
          shippingVolume
          Truck {
            id
            plateNumber
          }
          Job {
            id
            dealType
          }
          endWeightDifference
          startWeightDifference
        }
      }
      totalCount
      totalFilter
    }
  }
`

export const JOB_LOG_LIST = gql`
  query JobLogList (
    $jobId: Int!
  ) {
    JobLogList (jobId: $jobId) {
      id
      jobId
      editorId
      createdAt
      updatedAt
      Editor {
        userId
        firstname
        lastname
      }
      Job {
        id
        jobCode
      }
      Details {
        id
        jobLogId
        fieldName
        oldValue
        newValue
        createdAt
        updatedAt
      }
    }
  }
`

export const SHIPPING_ORDER_LOG_LIST = gql`
  query ShippingorderLogList (
    $shippingorderId: Int!
  ) {
    ShippingorderLogList (shippingorderId: $shippingorderId) {
      id
      shippingorderId
      editorId
      createdAt
      updatedAt
      Editor {
        userId
        firstname
        lastname
      }
      Shippingorder {
        id
        shippingCode
      }
      Details {
        id
        shippingorderLogId
        fieldName
        oldValue
        newValue
        createdAt
        updatedAt
      }
    }
  }
`
export const RECOMMEND_AVAILABLE_ORDER = gql`
  query recommendAvailableOrder (
    $startDestinationId: Int!
    $endDestinationId: Int!
  ) {
    recommendAvailableOrder(
      input: {
        startDestinationId: $startDestinationId
        endDestinationId: $endDestinationId
      }
    )
  }
`

export const TRUCK_USED_LOG = gql`
  query TruckUsedLog($truckId: Int!) {
    TruckUsedLogs(truckId: $truckId) {
      truckUsedLogs {
        id
        files {
          id
          url
        }
        driver {
          id
          fullname
        }
        endDate
        startDate
        trailer {
          id
          trailerPlate
        }
        truck {
          id
          plateNumber
        }
      }
    }
  }
`

export const RECOMMEND_FUEL_AMOUNT = gql`
  query RecommendFuelAmount($input: RecommendFuelAmountInput!) {
    recommendFuelAmount(input: $input) {
      recommendFuelAmount
      success
      message
    }
  }
`

export const GET_RECOMMEND_FUEL_LIST = gql`
  query RecommendFuelList(
    $limit: Int
    $offset: Int
    $senderLocationId: Int
    $receiverLocationId: Int
    $truckBrandId: Int
  ) {
    RecommendFuelList(input: {
      limit: $limit
      offset: $offset
      senderLocationId: $senderLocationId
      receiverLocationId: $receiverLocationId
      truckBrandId: $truckBrandId
    }) {
      lists {
        id
        amount
        senderLocationId
        receiverLocationId
        truckBrandId
        senderLocation {
          name
        }
        receiverLocation {
          name
        }
        truckBrand {
          name
        }
      }
      totalCount
    }
  }
`

export const GET_REMAINING_FUEL_BY_TRUCK = gql`
  query GetRemainingFuelByTruck($id: Int!) {
    GetRemainingFuelByTruck(id: $id) {
      success
      message
      remainingFuelList {
        remainingAmount
        usedAmount
        fuelOrder {
          shippingVolume
          shippingNumber
          ShippingOrder {
            id
          }
        }
      }
    }
  }
`
